import React, {Component} from 'react';
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types';
import {post,get} from "../../../server/actionsParent";
import Datetime from 'react-datetime';
import {formatDate} from "../../../server/util";
import {_addNotification, _addNotificationError} from '../../../server/util';
import moment from 'moment';
var valid = function (current) {
    return current.day() !== 0 && current.day() !== 6;
};
function compare(a, b) {
    if (a.firstName < b.firstName)
        return -1;
    if (a.firstName > b.firstName)
        return 1;
    return 0;
}
class Support extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            selectedTypeValue: '',
            selectedStudentValue: '',           
            selectedStudentUser: '',
            selectedStudentValue: '',
            supportDate: '',
            textareavalue: '',
            studentsList: [],
            issueTypeList:[]
        }
        this.issueTypeChange = this.issueTypeChange.bind(this);
        this.studentTypeChange = this.studentTypeChange.bind(this);
        this.handleSupportFormSubmit = this.handleSupportFormSubmit.bind(this);
        this.textareaChange = this.textareaChange.bind(this);
        this.getIssueTypes=this.getIssueTypes.bind(this);
    }
    componentWillMount = () => {        
        this.setState({
            studentsList: this.props.studentData           
        },this.getIssueTypes());       
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            studentsList: nextProps.studentData,            
        })
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getIssueTypes=()=>{
        this.setState({loading:true})
        // https://devapi2.mealmanage.com/mealManage/reports/emailSendStatus?email=parent7.charter@gmail.com&access_token=f0592c4a-ceda-4ccf-91d2-e622eba3fcb6
        get('/supportOptions',undefined,true
        ).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({
                loading:false,
                issueTypeList:data['Parent']||[]
            })
        }).catch(error => {
            this.setState({loading:false})
            console.log("Loading Menu Failed", error)
        })

    }
    issueTypeChange = (e) => {       
        this.setState({ selectedTypeValue: e.target.value });       
    }
    studentTypeChange = (e) => {
        this.state.studentsList.sort(compare).map((stud, index) => {
            if(stud.id == e.target.value){
                
                this.setState({ selectedStudentValue: e.target.value,selectedStudentUser: stud._links.self.href});
            }
        })              
    }
    textareaChange(event) {
        this.setState({textareavalue: event.target.value});
    }
    setSupportsDate = (e) => {
        this.refs.supportcalendar.closeCalendar()
        this.setState({supportDate: e})
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    handleSupportFormSubmit(event) {      
        event.preventDefault();
        let yearMonth = null;
        if(this.state.supportDate != ''){
        let date = new Date(this.state.supportDate);
        yearMonth = (date.getFullYear()+''+(('0' +(date.getMonth() + 1)).slice(-2)));
        }
        let supportInfo = {
            "userEmail":sessionStorage.getItem('loggedInUserInfo'),
            "issueType":this.state.selectedTypeValue,            
            "studentUser":this.state.selectedStudentUser,
            "orderIssueYearMonth":yearMonth,
            "isResolved":false,
            "customMessage":this.state.textareavalue,
            "loggedUser":sessionStorage.getItem('loggedInUserInfo')
            }
        post('/supportUsers?access_token=', JSON.stringify(supportInfo)).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.text();
        }).then(data => {
            console.log("Details saved successfully");
            this.setState({selectedTypeValue: '', supportDate: '', selectedStudentValue: '', textareavalue: ''});              
            _addNotification('Thank you! Our support team will contact you soon.', this);
            setTimeout(() =>
            window.location.replace('/parent')
            , 3000);
        }).catch(
            (error) => {
                console.log('Details not saved', error);
                _addNotificationError('Please try again!', this);
            }
        );
      }

    render() {
        return (
            <section className="full-width clearfix">
            <NotificationSystem ref="notificationSystem"/>
                <div className="container">
                    <div className="sectionTitle">
                    <div className="row">
                    <div className="col-md-6 col-sm-6 col-sm-6">
                        <h2 style={{width:'auto'}}>
                            <span>Support</span>
                        </h2>
                    </div>
                    <div className="col-md-6 col-sm-6 col-sm-6" style={{marginTop:'15px'}}>
                            <button className="pull-right btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                let _self=this;
                                _self.context.router.history.goBack() ;
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                    </div>    
                    </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center">
                                    <h3 className="panel-title">Support</h3>
                                </div>
                                <div className="panel-body parent-support-panel-body text-center">
                                    <form onSubmit={this.handleSupportFormSubmit}>
                                        <div className="col-md-6 col-md-offset-3">
                                            <div className="form-group">
                                                <select className="form-control" value={this.state.selectedTypeValue} onChange={this.issueTypeChange} required>
                                                    <option value="">Select issue type</option>
                                                   {/*  <option value="Order related issue">Order related issue</option>
                                                    <option value="Student profile related issue">Student profile related issue</option> */}
                                                    {this.state.issueTypeList.map((item,k)=>{
                                                        return <option key={k} value={item}>{item}</option>
                                                    })}
                                                </select>
                                            </div>
                                            {this.state.selectedTypeValue == '' ? null : this.state.selectedTypeValue == 'Order related inquiry' ?
                                            <div className="uploadFileInfo form-group"><div className="input-group col-md-12"><Datetime ref='supportcalendar' dateFormat="MMMM YYYY" timeFormat={false}
                                                      closeOnSelect={true}
                                                      onChange={this.setSupportsDate}
                                                       renderInput={this.renderInput} 
                                                       inputProps={{required: true}}
                                                       isValidDate={(currentDate)=>{
                                                                        let maxDate=moment().add(1, 'months');
                                                                        console.log(maxDate);
                                                                          return currentDate<=maxDate

                                                                      }}
                                                       /></div></div>
                                             : null}
                                            <div className="form-group">
                                                <select className="form-control" value={this.state.selectedStudentValue} onChange={this.studentTypeChange} required>
                                                <option value="">Select student</option>
                                                {this.state.studentsList.length !== 0 ? this.state.studentsList.sort(compare).map((stud, index) => {
                                                return <option value={stud.id}>{stud.firstName + ' ' + stud.lastName}</option>}) : null}
                                                    
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <textarea className="form-control" value={this.state.textareavalue} onChange={this.textareaChange} placeholder="Type message" style={{resize:'none'}} required>  
                                                </textarea>
                                            </div>
                                            <div className="form-group" style={{display:'block'}}>
                                                <input type="submit" className="btn btn-success" name="submit" value="Submit" style={{margin:'0'}}>  
                                                </input>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
        )
    }
}
Support.contextTypes = {
    router: PropTypes.object.isRequired
}
export default Support


// WEBPACK FOOTER //
// ./src/components/Parent/Home/support.js